import GenericModal from '@/components/shared/GenericModal';
import { constants } from '@/constants';
import useFeatureFlagsStore from '@/store/FeatureFlagsStore';

interface NoAdvisorsAvailableModalProps {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
}

const NoAdvisorsAvailableModal: React.FC<NoAdvisorsAvailableModalProps> = ({
  open,
  onClose,
  onContinue,
}) => {
  const featureFlags = useFeatureFlagsStore((state) => state.featureFlags);

  if (!featureFlags?.inBranchAppointments) {
    return null;
  }

  return (
    <GenericModal
      open={open}
      onClose={onClose}
      title='All of our virtual advisors are currently unavailable.'
      content='Please see if there are any available in-person appointments.'
      cancelButton={{
        label: 'Exit',
        href: constants.TRAVEL_HOME_PAGE_URL,
      }}
      continueButton={{
        label: 'In-person',
        onClick: onContinue,
      }}
      testIdPrefix='no-advisors-available-modal'
    />
  );
};

export default NoAdvisorsAvailableModal;
